import React from "react";
const FormatDate = (isoString) => {
  const date = new Date(isoString);

  // Format options
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  return date.toLocaleString("en-GB", options);
};
export default FormatDate;
